module.exports = __webpack_public_path__ + "static/media/003.df08f389.jpg";